import { defineStore } from "pinia";

const KEY_LAYOUT = "app/layout";

export default defineStore("app", {
  state: () => ({ layout: localStorage.getItem(KEY_LAYOUT) || "columns-4" }),
  getters: {},
  actions: {
    onLayoutChange(layout) {
      localStorage.setItem(KEY_LAYOUT, layout);
      this.layout = layout;
    },
  },
});
